// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kmUXw","rootNoMargin":"styles_rootNoMargin__Xxucw"};